import request from "@/utils/request";

// 查询列表
export const  listClassLibrary =(data) =>{
    return request({
        url: "/businessservice/classLibrary/listBook",
        method:"post",
        data: data
    })
}

// 查询详情
export const  infoLibrary =(query) =>{
    return request({
        url: "/businessservice/classLibrary/infoNew",
        method:"get",
        params: query
    })
}